import { render, staticRenderFns } from "./People.vue?vue&type=template&id=b89faa16&scoped=true&"
import script from "./People.vue?vue&type=script&lang=ts&"
export * from "./People.vue?vue&type=script&lang=ts&"
import style0 from "./People.vue?vue&type=style&index=0&id=b89faa16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b89faa16",
  null
  
)

export default component.exports